

































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import ErrorMessages from '@/components/ErrorMessages.vue'
import Icon from '@/components/Icon.vue'
import Password from '@/components/inputs/Password.vue'
import { validatePassword } from '@/utils/helpers'
import { UserModule } from '@/store/modules/user.module'
import { FacilityModule } from '@/store/modules/facility.module'
import Api from '@/api'
import { NoCache } from '@/decorators/NoCache'
import { ChainModule } from '@/store/modules/chain.module'
import { EOrigin } from '@zunta/configurations'

@Component({
  components: {
    Icon,
    Password,
    ErrorMessages
  }
})
export default class Register extends Vue {
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)

  password: string = ''
  repeatPassword: string = ''
  isValidPasswords: boolean = true
  isInvalidToken: boolean = false

  get facilities () {
    return this.$store.state.facility.facilities
  }

  get chain () {
    return this.$store.state.chain.chain
  }

  @NoCache
  get redirectUrl () {
    const user = Api.getUser()
    if (!user) {
      return { name: 'login' }
    }

    if (user.isDataEntry()) {
      return { name: 'admin-uploads' }
    }

    if (user.isAdmin()) {
      return { name: 'admin-chains' }
    }

    if (user.userRole === 'Admin' && this.facilities.length === 0) {
      if (!this.chain || this.chain.billingSoftware === EOrigin.PCC) {
        return { name: 'management-facilities-login' }
      }
      return { name: 'management-settings' }
    }

    if (user.isManager()) {
      return { name: 'management-todo' }
    }
  }

  async next () {
    this.isValidPasswords = true
    if (this.password !== this.repeatPassword || !validatePassword(this.password)) {
      this.isValidPasswords = false
      return
    }

    const response = await this.userModuleInstance.resetPassword({
      password: this.password,
      key: this.$route.query.key as string
    })

    if (response !== 'OK') {
      this.isInvalidToken = true
      return
    }

    const user = Api.getUser()
    if (user && user.data && user.data.chain) {
      await this.chainModuleInstance.getChainById(user.data.chain)
    }
    await this.facilityModuleInstance.getFacilityList({ limit: 1, skip: 0 })
    this.$router.push(this.redirectUrl as any)
  }
}
